import { useFormContext } from "react-hook-form";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";

interface AlignmentOption {
  icon: IconType;
  type: string;
}

export const AlignmentField = ({
  name,
  options,
  label,
}: {
  name: string;
  options: AlignmentOption[] | ReadonlyArray<AlignmentOption>;
  label: string;
}) => {
  const { watch, setValue } = useFormContext();
  const value = watch(name);

  return (
    <div className="flex w-full items-center justify-between">
      <label className="form-group__label text-dark text-xs font-normal">
        {label}
      </label>
      <div className="bg-tertiary flex items-center justify-start gap-px rounded-xl p-1">
        {options.map(button => (
          <button
            key={button.type}
            type="button"
            className={classNames(
              "flex items-center justify-center rounded-lg p-1.5",
              {
                "bg-primary": value === button.type,
                "bg-transparent": value !== button.type,
              },
            )}
            onClick={() => setValue(name, button.type)}
          >
            <Icon type={button.icon} size={20} />
          </button>
        ))}
      </div>
    </div>
  );
};
